export {
  Tag,
  type TagProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Tag';
